var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEninline = function SvgEninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#en_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#en_inline_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "en_inline_svg__c",
    width: 26,
    height: 26,
    x: -3,
    y: -4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.6-3.6H-2.604v25.204H22.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#en_inline_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002781",
    d: "M21.55-.45H-1.555A1.05 1.05 0 0 0-2.604.6v16.803a1.05 1.05 0 0 0 1.05 1.05H21.55a1.05 1.05 0 0 0 1.05-1.05V.6a1.05 1.05 0 0 0-1.05-1.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M20.173 2.218a.85.85 0 0 0-.847-.848h-2.188l-5.443 4.186V-.45h-3.39v6.006L2.861 1.37H.674a.85.85 0 0 0-.848.847v1.097l5.188 3.99H-.174v3.391h5.188l-5.188 3.991v1.096a.85.85 0 0 0 .848.848h2.188l5.442-4.186v6.009h3.391v-6.01l5.443 4.187h2.188a.85.85 0 0 0 .847-.848v-1.096l-5.188-3.99h5.188V7.304h-5.188l5.188-3.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D10D24",
    d: "M20.173 8.155h-9.325V-.45H9.152v8.605H-.174v1.696h9.326v8.602h1.696V9.85h9.325z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D10D24",
    d: "M8.304 10.583.497 16.616a1 1 0 0 0 .177.019h1.012l6.618-5.114zM11.696 7.423l7.808-6.033a1 1 0 0 0-.178-.019h-1.011l-6.619 5.115zM7.459 7.308.087 1.61a.84.84 0 0 0-.26.61v.127l6.419 4.96zM12.533 10.7l7.372 5.695a.84.84 0 0 0 .26-.609v-.127l-6.419-4.96z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "en_inline_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.003,
    height: 18.003,
    x: 0.996,
    fill: "#fff",
    rx: 9.001
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "en_inline_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-2.604-3.6H22.6v25.203H-2.604z"
  })))));
};
export default SvgEninline;